import React, { useEffect, useContext, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { AppSettings } from './../../config/app-settings.js'
import * as Yup from 'yup'
import Loader from '../pages/loader.js'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'

const validationSchema = Yup.object({
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required')
})

function ForgotPassword () {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)
  const navigate = useNavigate()

  const context = useContext(AppSettings)

  useEffect(() => {
    context.setAppHeaderNone(true)
    context.setAppSidebarNone(true)
    context.setAppContentClass('p-0')

    return () => {
      context.setAppHeaderNone(false)
      context.setAppSidebarNone(false)
      context.setAppContentClass('')
    }
  }, [context])

  const validation = useFormik({
    initialValues: {
      email: ''
    },
    validationSchema,
    onSubmit: async values => {
      setIsLoading(true)
      setError(false)
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}users/forgot-password/`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(values)
          }
        )

        const data = await response.json()

        if (!response.ok) {
          throw new Error(data?.errors[0]?.message || 'Something went wrong')
        }

        toast.success('Password reset link sent successfully')
        navigate('/login')
      } catch (err) {
        setError(err.message)
        toast.error(err.message)
      } finally {
        setIsLoading(false)
      }
    }
  })

  return (
    <div className='login'>
      <Loader isLoading={isLoading} />
      <div className='login-content'>
        <form onSubmit={validation.handleSubmit}>
          <h1 className='text-center'>Reset Password</h1>

          <div className='mb-3'>
            <label className='form-label'>
              Email Address <span className='text-danger'>*</span>
            </label>
            <input
              id='email'
              name='email'
              type='email'
              value={validation.values.email}
              onChange={validation.handleChange}
              className='form-control form-control-lg bg-white bg-opacity-5'
              onBlur={validation.handleBlur}
              placeholder='Enter your email'
            />
            {validation.touched.email && validation.errors.email && (
              <div className='text-danger mt-1'>{validation.errors.email}</div>
            )}
          </div>

          <button
            type='submit'
            className='btn btn-outline-theme btn-lg d-block w-100 fw-500 mb-3'
            disabled={isLoading}
          >
            {isLoading ? 'Loading...' : 'Reset Password'}
          </button>
        </form>
        <Link to={'/login'} className='text-center'>
            <p>Go Back to Login</p>
        </Link>
        {error && (
          <div className='mt-2 text-center text-sm text-danger'>{error}</div>
        )}
      </div>
    </div>
  )
}

export default ForgotPassword
